import {Button, message, Modal, Table} from "antd";
import {memo, useEffect, useState} from "react";
import {instance, instance_2} from "../../../../../API/API";

export const AddModal = memo(({visible, record, onClose, onSave}) => {
    const [objects, setObjects] = useState([]);
    const [serviceObjects, setServiceObjects] = useState([]);
    const [availableObjects, setAvailableObjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addingIds, setAddingIds] = useState([]);

    const getObjectData = async () => {
        setLoading(true);
        try {
            // Получаем все объекты (тип 1 - актуальные)
            const objects_req = await instance.get(`objects/getObjects.php?showActual=1`);
            if (objects_req.data.success && objects_req.data.objects) {
                setObjects(objects_req.data.objects);
            }

            // Получаем объекты на обслуживании
            const serviceRes = await instance_2.get(`finance/getIncome.php?active=0`);
            if (serviceRes.data && serviceRes.data.income) {
                setServiceObjects(serviceRes.data.income);
            }
        } catch (e) {
            console.error(e);
            message.error('Ошибка загрузки данных');
        } finally {
            setLoading(false);
        }
    };

    // Вычисляем объекты, которых нет в обслуживании
    useEffect(() => {
        if (objects.length > 0 && serviceObjects.length > 0) {
            // Получаем ID объектов, которые уже на обслуживании
            const serviceObjIds = new Set(
                serviceObjects.map(item => Number(item.obj_id))
            );

            // Фильтруем объекты, которых нет в обслуживании
            const available = objects.filter(obj => !serviceObjIds.has(Number(obj.id)));
            setAvailableObjects(available);
        } else if (objects.length > 0 && serviceObjects.length === 0) {
            // Если нет объектов в обслуживании, показываем все
            setAvailableObjects(objects);
        }
    }, [objects, serviceObjects]);

    useEffect(() => {
        if (visible) {
            getObjectData();
        }
    }, [visible]);

    const handleAddToService = async (object) => {
        setAddingIds(prev => [...prev, object.id]);

        try {
            // Здесь должен быть API запрос для добавления объекта в обслуживание
            // Пример: POST /finance/addIncome.php
            const response = await instance_2.post(`finance/addIncomeObject.php`, {
                obj_id: object.id,
                obj_name: object.name,
                type: 1, // или 2 в зависимости от типа
                nds: 0,
                cost: "0`0`0`0`0`0`0`0`0`0`0`0" // начальная стоимость
            });

            if (response.data.success) {
                message.success(`Объект "${object.name}" добавлен в обслуживание`);
                // Обновляем списки
                await getObjectData();
                if (onSave) onSave();
            } else {
                message.error(response.data.error || 'Ошибка добавления');
            }
        } catch (error) {
            console.error('Error adding to service:', error);
            message.error('Ошибка при добавлении объекта');
        } finally {
            setAddingIds(prev => prev.filter(id => id !== object.id));
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 50,
        },
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            width: 200,
        },
        {
            title: 'Полное название',
            dataIndex: 'long_name',
            key: 'long_name',
            width: 200,
            render: (text) => text || '—',
        },
        {
            title: 'Тип',
            dataIndex: 'type',
            key: 'type',
            width: 80,
            render: (type) => {
                switch (Number(type)) {
                    case 1:
                        return 'Актуальный';
                    case 2:
                        return 'Временный';
                    case 3:
                        return 'Архивный';
                    default:
                        return type;
                }
            },
        },
        {
            title: 'Действия',
            key: 'action',
            width: 150,
            render: (_, record) => (
                <Button
                    type="link"
                    size="small"
                    loading={addingIds.includes(record.id)}
                    onClick={() => handleAddToService(record)}
                >
                    Добавить к обслуживанию
                </Button>
            ),
        },
    ];

    return (
        <Modal
            title="Добавление объекта к обслуживанию"
            open={visible}
            onCancel={onClose}
            width={1000}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Закрыть
                </Button>
            ]}
        >
            <Table
                columns={columns}
                dataSource={availableObjects}
                rowKey="id"
                loading={loading}
                pagination={false}
                scroll={{x: 1000}}
                locale={{
                    emptyText: loading ? 'Загрузка...' : 'Нет доступных объектов для добавления'
                }}
            />
        </Modal>
    );
});

AddModal.displayName = 'AddModal';